module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"label":"UID","placeholder-country-ch":"Ex: {example}","placeholder-country-row":"UID eingeben"},"fr":{"label":"IDE","placeholder-country-ch":"Ex.: {example}","placeholder-country-row":"Saisir IDE"},"it":{"label":"IDI","placeholder-country-ch":"Es: {example}","placeholder-country-row":"Immettere l\u0027IDI"}}')
  delete Component.options._Ctor
}
